module.exports = __webpack_public_path__ + "static/img/html-css-js.84a29ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/html-css-js.png
// module id = 3CKv
// module chunks = 1